import React from 'react';
import RadialGauge from '@splunk/dashboard-visualizations/RadialGauge';

export default () => (
    <RadialGauge
        options={{ 'chart.showRangeBand': false }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'count' }],
                    columns: [['78']],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
